import VueConfig from "../../vue.config";
import InputValueConversion from "../../libs/InputValueConversion.js";

const buyStateMutations = {
  setFormItems(state, payload) {
    const name = payload.name;
    const value = payload.value;
    state.formItems[name] = value;
  },
  setFormLabels(state, payload) {
    const name = payload.name;
    const value = payload.value;
    state.formLabels[name] = value;
  },
  setFormLabelsList(state, payload) {
    payload.forEach(item => {
      const name = item.name;
      const value = item.value;
      state.formLabels[name] = value;
    });
  },
  setSiteCode(state, siteCode) {
    state.siteCode = siteCode;
  },
  setAssessmentResultAnswerValue(state, value) {
    state.formLabels.assessmentResultAnswerValue = value;
  }
}
const buyStateActions = {
  updateFormItems(store, formItem) {
    store.commit('setFormItems', formItem);
  },
  updateFormLabels(store, formLabel) {
    store.commit('setFormLabels', formLabel);
  },
  updateFormLabelsList(store, formItem) {
    store.commit('setFormLabelsList', formItem);
  },
  // 買取状況取得
  async retrieveBuyState({state, commit, dispatch},buyStateResults) {
    if (Object.keys(buyStateResults).length > 0) {
      const result = buyStateResults
      commit('setFormLabels', {name: 'pickupPeriodName', value: result.timeNm});
      commit('setFormLabels', {name: 'customerStatusCode', value: result.kaitori.customer_status_code});
      commit('setFormLabels', {name: 'stateOfBuy', value: result.kaitori.torihiki_jyotai});
      commit('setFormLabels', {name: 'cancelReasonCode', value: result.kaitori.torihiki_cancel_reason});
      commit('setFormLabels', {name: 'totalCount', value: result.totalCnt});
      commit('setFormLabels', {name: 'okCount', value: result.okCnt});
      commit('setFormLabels', {name: 'gTotalInput', value: result.gtotalInput});
      if (!this.isCharibon) {
        commit('setFormLabels', {name: 'methodOfPayment', value: result.kaitori.hurikomi_houhou});
      }
      // 買取番号
      commit('setFormItems', {name: 'buyNumber', value: result.kaitori.kaitori_num});

      // 集荷箱数
      commit('setFormLabels', {name: 'numberOfPackages', value: result.boxcount});

      // 日付を表示用に格納して整形
      // 20220726 shukaYmd 集荷日
      const sourceDate = result.shukaYmd;
      const shukaYmd = sourceDate.slice(0, 4) + "-" + sourceDate.slice(4, 6) + "-" + sourceDate.slice(6);
      const displayDate = InputValueConversion.convertedToDateStringForDisplay(shukaYmd)
      commit('setFormLabels', {name: 'pickupDate', value: displayDate});

      // 集荷日更新フォームに初期値設定
      dispatch('setPickupPackagesForm', {boxcount: result.boxcount, shukaYmd: shukaYmd, timeCode: result.timeCode, timeNm: result.timeNm});

      // 申し込み日
      const dateOfApplication = InputValueConversion.convertedToDateStringForDisplay(result.kaitori.moushikomi_dtm)
      commit('setFormLabels', {name: 'dateOfApplication', value: dateOfApplication});

      if (state.siteCode === VueConfig.siteCode.charibon) {
        // 支援先団体
        commit('buy/setFormItems', {name: 'supportGroupId', value: result.supportGroupId}, { root: true });
        commit('setFormLabels', {name: 'supportGroupName', value: result.supportGroupName});
      }
      // 状態変更日
      let dateOfChangeApplicationState;
      if (state.formLabels.customerStatusCode === "B01") {
        dateOfChangeApplicationState = InputValueConversion.convertedToDateStringForDisplay(result.arrivalYmd)
      } else {
        dateOfChangeApplicationState = InputValueConversion.convertedToDateStringForDisplay(result.kaitori.torihiki_kekka_dtm)
      }
      commit('setFormLabels', {name: 'dateOfChangeApplicationState', value: dateOfChangeApplicationState});

      // 取引終了日
      const dateOfEndBuyState = InputValueConversion.convertedToDateStringForDisplay(result.kaitori.torihiki_end_dtm)
      commit('setFormLabels', {name: 'dateOfEndBuyState', value: dateOfEndBuyState});

      // 適用済みクーポン
      commit('setFormLabels', {name: 'isCouponChangeable', value: result.coupon.isChangeable});
      commit('setFormLabels', {name: 'couponChangePossibleDateTime', value: result.coupon.changePossibleDateTime});
      commit('buy/setFormItems', {name: 'campaignCode', value: result.coupon.appliedCouponCode}, { root: true });
      commit('buy/setFormLabels', {name: 'campaignName', value: result.coupon.appliedCouponName}, { root: true });
      commit('buy/setFormLabels', {name: 'appliedCouponCode', value: result.coupon.appliedCouponCode}, { root: true });
      commit('buy/setFormLabels', {name: 'appliedCouponName', value: result.coupon.appliedCouponName}, { root: true });
      return result;
    } else {
      return false;
    }
  },
  // 集荷日変更情報取得
  async populatePickupPackages({state, commit}, buyPickupStateResults) {
    if (Object.keys(buyPickupStateResults).length > 0) {
      commit('setFormLabels', {name: 'isPickupDateChangeable', value: buyPickupStateResults.isChangeable});
      commit('buy/setFormLabels', {name: 'isShippingFree', value: buyPickupStateResults.isShippingFree}, { root: true });
      commit('setFormLabels', {name: 'pickupDateChangePossibleDateTime', value: buyPickupStateResults.changePossibleDateTime});
      return true;
    } else {
      return false;
    }
  },
  // フォームに集荷日情報設定
  setPickupPackagesForm({commit}, payload) {
    const boxcount = payload.boxcount;
    const shukaYmd = payload.shukaYmd;
    const timeCode = payload.timeCode;
    const timeNm = payload.timeNm;
    commit('buy/setFormItems', {name: 'numberOfPackages', value: boxcount}, { root: true });
    commit('buy/setFormItems', {name: 'pickupDate', value: shukaYmd}, { root: true });
    commit('buy/setFormItems', {name: 'pickupTimeCode', value: timeCode}, { root: true });
    commit('buy/setFormLabels', {name: 'pickupPeriodName', value: timeNm}, { root: true });
    // 元に戻すためのバックアップ
    commit('buy/setFormLabels', {name: 'pickupPackagesBackup', value: {
        boxcount: boxcount,
        shukaYmd: shukaYmd,
        timeCode: timeCode,
        timeNm: timeNm,
      }}, { root: true });
  },
  // 集荷日更新処理
  async updatePickupPackages({state, commit, rootState}){
    const buyState = rootState.buy;
    const response = await axios.post("/api/buy/state/pickup/save", {
      site_code: state.siteCode,
      boxcount: buyState.formItems.numberOfPackages ,
      shuka_ymd: buyState.formItems.pickupDate.replace(/-/g, ''),
      shuka_time_code: buyState.formItems.pickupTimeCode,
      vbOfficeCode: buyState.formItems.vbOfficeCode,
    }).catch((err) => {
      console.error("Catch" + err);
      return false;
    });
    if (response && response.data.result) {
      commit('setFormLabels', {name: 'numberOfPackages', value: buyState.formItems.numberOfPackages});
      commit('setFormLabels', {name: 'pickupPeriodName', value: buyState.formLabels.pickupPeriodName});

      // 日付を表示用に格納して整形
      // this.buyFormItems.pickupDate yyyy-MM-DD
      const displayDate = InputValueConversion.convertedToDateStringForDisplay(buyState.formItems.pickupDate)
      commit('setFormLabels', {name: 'pickupDate', value: displayDate});
      return true;
    } else {
      return false;
    }
  },
  // 集荷先住所の取得
  async retrieveAddress({state, commit, dispatch}, buyAddressResults){
    if(Object.keys(buyAddressResults).length > 0){
      const data = buyAddressResults;
      // 更新用初期値のセット
      const addressInfo = [
        {name: 'addressPrefecture', value: data.addressPrefecture},
        {name: 'addressLocal1', value: data.addressLocal1},
        {name: 'addressLocal2', value: data.addressLocal2},
        {name: 'postcode',value: data.postcode},
        {name: 'companyName',value: data.companyName},
        {name: 'firstname', value: data.firstname},
        {name: 'lastname',value: data.lastname},
        {name: 'firstnameKatakana',value: data.firstnameKatakana},
        {name: 'lastnameKatakana',value: data.lastnameKatakana},
        {name: 'telephoneNumber1',value: data.telephoneNumber1},
        {name: 'telephoneNumber2',value: data.telephoneNumber2},
        {name: 'telephoneNumber3',value: data.telephoneNumber3},
        {name: 'jobCode',value: data.jobCode},
        {name: 'jobLabel',value: data.jobLabel},
        {name: 'birthdate',value: data.birthdate}
      ];
      commit('buy/setFormItemsList', addressInfo, { root: true }); // 住所変更フォーム初期値を設定
      dispatch('setBirthdateForm', data.birthdate);    // 住所変更フォーム誕生日の初期値を設定
      commit('setFormLabelsList', addressInfo); // 住所変更フォーム参照画面の初期値を設定
      commit('buy/setFormLabels', {name: 'pickupAddressBackup', value: addressInfo}, { root: true }); // 住所変更を戻すためのバックアップ

      commit('buy/setFormItems', {name: 'identitySubmissionMethodCode', value: 1 }, { root: true });
      commit('setFormLabels', {name: 'isAccountChangeable', value: data.isChangeable});
      return true;
    } else {
      return false;
    }
  },
  // 集荷先住所変更フォームの誕生日を設定する。引数は文字列YYYY-M-D
  setBirthdateForm({commit}, birthdateStr) {
    // FIXME: フォームの値を誕生日のみラベルで持っている(要LPリファクタ)
    const birthdateStrArr = birthdateStr.split('-');
    commit('buy/setFormLabels', {name: 'birthdateYear', value: birthdateStrArr[0]}, { root: true })
    // 左側を0埋めする。そうしないと更新時にサーバー側検証で弾かれる。
    commit('buy/setFormLabels', {name: 'birthdateMonth', value: birthdateStrArr[1].padStart(2, '0')}, { root: true })
    commit('buy/setFormLabels', {name: 'birthdateDay', value: birthdateStrArr[2].padStart(2, '0')}, { root: true })
  },
  // 本人確認書類の登録状況確認
  async retrieveIdentityState({state, commit}, buyIdentityResults) {
    let isUploadRegistrable = null;
    let errorDialogForGet = false;
    if(Object.keys(buyIdentityResults).length > 0){
      isUploadRegistrable = buyIdentityResults.isRegistrable;
      if(!isUploadRegistrable){
        let messageText;
        switch (buyIdentityResults.status){
          case 'A1':
            messageText = 'データ不整合です。お手数ですが買取ナンバーと合わせてお問合せください。 A1'
            break;
          case 'B2':
            messageText = 'ご登録いただいた内容は査定結果ご報告時に確認の上、ご連絡致します。査定が完了するまで今しばらくお待ちください。'
            break;
          case 'C1':
            messageText = '取引中の買取がある場合は変更できません。'
            break;
          case 'E1':
            messageText = '本人確認の身分証は同梱を選択されています。ここでの登録は不要です。'
            break;
          case 'D1':
            messageText = '取引は終了しています。'
            break;
          default:
            messageText = 'データ不整合です。お手数ですが買取ナンバーと合わせてお問合せください。 ステータスコード:' + response.data.status
        }
        commit('setFormLabels', {name: 'messageUploadText', value: messageText});
      }
    } else {
      errorDialogForGet = true;
    }
    return {
      isUploadRegistrable: isUploadRegistrable,
      isErrorDialogForGet: errorDialogForGet,
    };
  },
  // 銀行口座の登録状況確認
  async retrieveBankState({state, commit}, buyBankResults) {
    let isBankRegistrable = null;
    let errorDialogForGet = false;
    if(Object.keys(buyBankResults).length > 0){
      isBankRegistrable = buyBankResults.isRegistrable;
      if(isBankRegistrable){
        if(buyBankResults.status === "B2"){
          // B2は振込失敗 初回登録時の情報をセット
          const customerKouza = buyBankResults.customerKouza
          const addressInfo = [
            {name: 'kouza_type', value: customerKouza.kouza_type},
            {name: 'bankCode', value: customerKouza.bank_code},
            {name: 'branchCode', value: customerKouza.bank_shiten},
            {name: 'yuucyo_kigou', value: customerKouza.yuucyo_kigou},
            {name: 'yuucyo_hansu', value: customerKouza.yuucyo_hansu},
            {name: 'yuucyo_kouza', value: customerKouza.yuucyo_kouza},
            {name: 'bankType', value: customerKouza.bank_shubetu},
            {name: 'bankAccountNumber', value: customerKouza.bank_kouza},
            {name: 'bankAccountName', value: customerKouza.bank_meigi},
          ];
          commit('buy/setFormItemsList', addressInfo, { root: true });
          commit('buy/setFormLabels', {name:'bankName', value: customerKouza.disp_ginkou}, { root: true });
          commit('buy/setFormLabels', {name:'branchName', value: customerKouza.disp_shiten}, { root: true });
        }
      }else{
        let messageText;
        switch (buyBankResults.status){
          case 'A':
            messageText = 'データ不整合です。お手数ですが買取ナンバーと合わせてお問合せください。 ステータスコード: A';
            break;
          case 'B1':
            messageText = 'ただいま再振込を行っています。終了までしばらくお待ちください。';
            break;
          case 'C1':
            messageText = 'ご登録いただいた内容は査定結果ご報告時に確認の上、ご連絡致します。査定が完了するまで今しばらくお待ちください。';
            break;
          case 'D1':
            messageText = '取引中の買取がある場合は口座情報を変更できません。';
            break;
          case 'D2':
          case 'E1':
            messageText = '取引は終了しています。';
            break;
          default:
            messageText = 'データ不整合です。お手数ですが買取ナンバーと合わせてお問合せください。 ステータスコード:' + buyBankResults.status
        }
        commit('setFormLabels', {name: 'messageBankText', value: messageText});
      }
    } else {
      errorDialogForGet = true;
    }
    return {
      isBankRegistrable: isBankRegistrable,
      isErrorDialogForGet: errorDialogForGet,
    }
  },
}
const buyStateGetters = {
  getFormItems: (state) => {
    return state.formItems;
  },
  getFormLabels: (state) => {
    return state.formLabels;
  },
}

const defaultBuyState = () => {
  return {
    siteCode: null,
    formItems: {
      email: null,
      buyNumber: null,
    },
    formLabels: {
      pickupDate: '2022-01-02',
      pickupTimeCode: 'A1',
      pickupPeriodName: null,
      numberOfPackages: null,
      dateOfApplication: null,
      dateOfChangeApplicationState: null,
      dateOfEndBuyState: null,
      customerStatusCode: null,
      methodOfPayment: null,
      stateOfBuy: null,
      cancelReasonCode: null,
      totalCount: null,
      okCount: null,
      gTotalInput: 0,
      addressPrefecture: null,
      addressLocal1: null,
      addressLocal2: null,
      postcode: null,
      firstname: null,
      lastname: null,
      firstnameKatakana: null,
      lastnameKatakana: null,
      birthdate: null,
      telephoneNumber1: null,
      telephoneNumber2: null,
      telephoneNumber3: null,
      jobCode: null,
      jobLabel: null,
      messageBankTitle: "口座登録",
      messageBankSubTitle: "",
      messageBankText: "bank text",
      messageUploadTitle: "本人確認書類",
      messageUploadSubTitle: "",
      messageUploadText: "upload text",
      buyStateNoticeMessage: null,
      buyStateErrorMessage: null,
      isBuyStateWrong: false,
      companyName: null,
      supportGroupId: null,
      supportGroupName: null,
      isPickupDateChangeable: false,
      pickupDateChangePossibleDateTime: null,
      couponChangePossibleDateTime: null,
      isAccountChangeable: false,
      isCouponChangeable: false,
      assessmentResultAnswerValue: 1
    },
  }
}

const moduleBuyState = {
  namespaced: true,
  state: defaultBuyState(),
  mutations: buyStateMutations,
  actions: buyStateActions,
  getters: buyStateGetters
}

export {moduleBuyState};